import { gql } from '@apollo/client';

export const ADD_SITES_TO_INDICATOR = gql`
  mutation AddSitesToIndicator($input: UpsertIndicatorSitesInput!) {
    indicator: addSitesToIndicator(input: $input) {
      id
    }
  }
`;
